























import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import router from '../../../router';
import FormHeader from '../../molecules/FormHeader.vue'

export default createComponent({
  setup(props, context) {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
       const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }

    const selected = computed(() => companyRecruitment.jobSaveDraft.selected);
    const dialog = computed(() => displayui.dialogDeleteJobDraf);
    const openDialog = computed(() => displayui.openDeleteJobDialogDraf);
    const closeDialog = computed(() => displayui.closeDeleteJobDialogDraf);
    const resetTableValue = companyRecruitment.resetTableValue;
    const getListPrefecture = companyRecruitment.getListPrefecture;

    const deleteJobDetail =  async() => {
      await companyRecruitment.deleteJob(selected.value)
      await displayui.closeDeleteJobDialogDraf()
      await companyRecruitment.searchJob('','','','')
    }
    return {
      dialog,
      openDialog,
      closeDialog,
      deleteJobDetail
    };
  },

  components : {
    FormHeader,
  },
})
